<template>
  <div>
    <div class="chat-index">
      <div class="row">
        <div class="col-md-4" style="padding-right: 0px;">
          <div class="chat-sidebar">
            <h3>Chats <!--<img src="/img/icon.png"/>--></h3>
            <input type="text" placeholder="Search conversations">
            <div class="tabs">
            <h6 class="ongoing-con" :class="{ actTab: activeTab === 'unresolved' }" @click="activeTab = 'unresolved'">Unresolved ({{ unresolvedCount }})</h6>
            <h6 class="ongoing-con" :class="{ actTab: activeTab === 'resolved' }" @click="activeTab = 'resolved'">Resolved ({{ resolvedCount }})</h6>
            <!-- <h6 class="ongoing-con" style="margin-right: 0px;" :class="{ actTab: activeTab === 'admin' }" @click="activeTab = 'admin'">Admin ({{ adminCount }})</h6> -->
          </div>
          <div class="clearfix"></div>
      <!-- Chat List -->
      <div class="chat-box">
        <!-- Unresolved -->
        <div v-if="activeTab === 'unresolved'">
          <div v-for="chatUser in unresolvedUsers" :key="chatUser.id">
            <div class="chatBox" :class="{ active: $route.params.userId == chatUser.id }" v-if="chatUser.chat != 'Admin chat'">
              <router-link :to="'/sadmin/user-chat/' + chatUser.id">
                <div class="row">
                  <div class="col-md-3" style="padding-right: 11px;">
                    <img v-if="chatUser.image" :src="chatUser.image" />
                    <img v-else src="/img/userChat.png" />
                  </div>
                  <div class="col-md-9" style="padding-left: 0px;">
                    <h5>{{ chatUser.name }}</h5>
                    <h6>
                      <span v-if="chatUser.isReceived == 1" class="userRep"></span>
                      <img v-else src="/img/LeftReply.png" style="margin-right: 2px;" />
                      {{ chatUser.chat }}
                    </h6>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <!-- Resolved -->
        <div v-if="activeTab === 'resolved'">
          <div v-for="chatUser in resolvedUsers" :key="chatUser.id">
            <div class="chatBox" :class="{ active: $route.params.userId == chatUser.id }">
              <router-link :to="'/sadmin/user-chat/' + chatUser.id">
                <div class="row">
                  <div class="col-md-3" style="padding-right: 11px;">
                    <img v-if="chatUser.image" :src="chatUser.image" />
                    <img v-else src="/img/userChat.png" />
                  </div>

                  <div class="col-md-9" style="padding-left: 0px;">
                    <h5>{{ chatUser.name }}</h5>
                    <h6>
                      <span v-if="chatUser.isReceived == 1" class="userRep"></span>
                      <img v-else src="/img/LeftReply.png" style="margin-right: 2px;" />
                      {{ chatUser.chat }}
                    </h6>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <!-- Resolved -->
        <div v-if="activeTab === 'admin'">
          <div v-for="chatUser in AdminData" :key="chatUser.id">
            <div class="chatBox" :class="{ active: $route.params.userId == chatUser.id }" v-if="chatUser.chat == 'Admin chat'">
              <router-link :to="'/sadmin/user-chat/' + chatUser.id">
                <div class="row">
                  <div class="col-md-3" style="padding-right: 11px;">
                    <img v-if="chatUser.image" :src="chatUser.image" />
                    <img v-else src="/img/userChat.png" />
                  </div>

                  <div class="col-md-9" style="padding-left: 0px;">
                    <h5>{{ chatUser.name }}</h5>
                    <h6>
                      <span v-if="chatUser.isReceived == 1" class="userRep"></span>
                      <img v-else src="/img/LeftReply.png" style="margin-right: 2px;" />
                      {{ chatUser.chat }}
                    </h6>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
          </div>
        </div>
        <div class="col-md-8" style="padding-left: 0px;">
          <div class="welcome-chat">
            <img src="/img/pickl-logo.png">
            <h4>Welcome to the Admin Chat Panel. Select a user to view and manage conversations.</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LiveChat',
  data () {
    return {
      message: '',
      chatUsers: [],
      AdminData: [],
      activeTab: 'unresolved',
      resolvedUsers: [],
      unresolvedUsers: [],
      resolvedCount: '',
      unresolvedCount: '',
      adminCount: ''
    }
  },
  mounted () {
    this.scrollToBottom()
    this.getUserChats()
  },
  updated () {
    this.scrollToBottom()
  },
  methods: {
    scrollToBottom () {
      this.$nextTick(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        })
      })
    },
    getUserChats () {
      this.loadingPickls = true
      this.$http
        .get('chat-users')
        .then((response) => {
          this.chatUsers = response.body.data
          this.AdminData = response.body.AdminData
          this.unresolvedCount = response.body.unresolvedCount
          this.adminCount = response.body.adminCount
          this.resolvedUsers = response.body.resolvedUsers
          this.unresolvedUsers = response.body.unresolvedUsers
          this.resolvedCount = response.body.resolvedCount
        })
        .catch((error) => {
          console.error('Error fetching chats:', error)
        })
        .finally(() => {
          this.loadingPickls = false
        })
    }
  }
}
</script>

<style>
.chat-index h3 img{
    width: 30px;
    float: right;
    margin-top: 6px;
}
.chat-padd {
    padding: 0px;
}
.chat-sidebar {
    background: #fff;
    height: 100vh;
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.6);
    padding: 30px 10px 10px 10px;
}
.chat-index h3 {
    margin-top: 0px;
    color: #000;
    font-size: 28px;
    font-weight: 800;
    position: relative;
}
.chat-sidebar input{
    background: #ECEFF2;
    border: 0px;
    border-radius: 20px;
    height: 40px;
    font-size: 15px;
    padding-left: 40px;
    margin-top: 10px;
    margin-bottom: 5px;
}
.chat-sidebar h3::after{
    position: absolute;
    z-index: 1;
    content: "";
    background-image: url('/img/SearchChat.png');
    width: 21px;
    height: 21px;
    left: 10px;
    bottom: -52px;
    background-size: 100%;
}
.chat-sidebar .col-md-3 img{
    border-radius: 50%;
    width: 65px;
    height: 65px;
}
.ongoing-con {
    font-size: 14px;
    float: left;
    margin-right: 14px;
    background: #ECEFF2;
    padding: 10px 12px;
    border-radius: 12px;
    cursor: pointer;
}
.chatBox{
    margin-bottom: 15px;
    padding: 5px 10px;
    border-radius: 18px;
}
.chatBox:hover{
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.4);
}
.chatBox h5{
    font-size: 16px;
    color: #000;
    margin-bottom: 5px;
}
.chatBox h6{
    margin-top: 0px;
    font-size: 14px;
    color: #555;
}
.chatHeader {
    padding: 7px 15px;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.6);
}
.chatHeader h4{
    margin-top: 20px;
    color: #000;
    font-size: 20px;
    margin-bottom: 5px;
}
.chatHeader h6{
    margin-top: 0px;
    font-size: 14px;
}
.chatHeader button {
    background: #B2CEB3;
    color: #000;
    border: 0px;
    margin-right: 25px;
    padding: 7px 20px;
    border-radius: 16px;
    font-size: 15px;
    margin-top: 22px;
}
.userChat {
    padding-left: 25px;
    padding-top: 20px;
    margin-top: 5px;
}
.chatList {
    background: #F2F3F7;
    min-height: 530px;
    margin-left: 4px;
}
.userChat p{
    background: #fff;
    padding: 10px 20px;
    border-radius: 13px;
    font-size: 15px;
    box-shadow: 2px 0px 2px rgba(0, 0, 0, 0.1);
}
.userChat img,
.adminChat img {
    max-width: 100%;
    margin-top: 40px;
}
.userChat h5{
    font-size: 15px;
    color: #000;
    margin-bottom: 5px;
}
.userChat h5 span{
    color: #969696;
    font-size: 11px;
    font-weight: normal;
}
.adminChat p{
    background: #782B55;
    padding: 10px 20px;
    border-radius: 13px;
    color: #fff;
    font-size: 15px;
    box-shadow: 2px 0px 2px rgba(0, 0, 0, 0.1);
}
.adminChat h5{
    font-size: 15px;
    color: #000;
    margin-bottom: 5px;
    text-align: right;
}
.adminChat h5 span{
    color: #969696;
    font-size: 11px;
    font-weight: normal;
}
.adminChat {
    padding-right: 20px;
}
.chatTime {
    text-align: center;
    display: block;
    z-index: 9;
    position: relative;
    padding-top: 15px;
    margin-top: 4px;
}
.chatTime:after{
    width: 96%;
    height: 1px;
    position: absolute;
    background: #C3C3C3;
    z-index: -3;
    content: "";
    left: 2%;
    top: 21px;
}
.chatTime::before{
    content: "";
    position: absolute;
    width: 120px;
    height: 30px;
    background: #F2F3F7;
    z-index: -1;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 15px;
}
.chat-sidebar {
    position: fixed;
    width: 26%;
    padding-bottom: 40px;
    overflow-y: scroll;
}
::-webkit-scrollbar {
  width: 0px;
}
.chatMessage textarea{
    margin-bottom: 0px;
    border: 0px;
    width: 96%;
    margin-left: 2%;
    border-radius: 13px;
    resize: none;
    font-size: 15px;
    margin-top: 20px;
    position: fixed;
    bottom: 10px;
    right: 20px;
    width: 50%;
    padding: 20px;
}
.chatMessage button{
    position: fixed;
    right: 50px;
    bottom: 20px;
    border: 0px;
    background: #3A5B3C;
    width: 56px;
    height: 56px;
    border-radius: 50%;
}
.chatMessage button img{
    width: 35px;
}
.chatMessage button:disabled{
    background: #B2CEB3 !important;
}
.welcome-chat {
    text-align: center;
    padding-top: 75px;
}
.welcome-chat img {
    max-width: 90px;
}
.welcome-chat h4 {
    font-size: 24px;
    margin-top: 20px;
    color: #000;
    padding: 0 20px;
    line-height: 30px;
}
.userRep {
    width: 8px;
    height: 8px;
    background: #12DA6D;
    display: inline-block;
    border-radius: 50%;
    margin-right: 3px;
}
.actTab{
    background: #782b54;
    color: #fff;
}
</style>
